import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { ButtonComponent } from "../../button/button.component";

@Component({
    selector: "rask-info-modal-component",
    templateUrl: "./info.component.html",
    styleUrls: ["./info.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ButtonComponent]
})
export class InfoModalComponent implements OnInit {
    activeModal = inject(NgbActiveModal);

    content: string;
    okCaption: string;

    cancel = ConfirmDialogResponse.cancel;
    ngOnInit(): void {
        document.getElementById("ok").focus();
    }
}
